import React, {Component} from "react";
import './FontOptionItem.css'
import {api} from "../../data/urls";
import axios from "axios";
import returnAuthHeaderForAJAX from "../../helpers/auth/returnAuthHeaderForAJAX";
import {openNotification} from "../../helpers/openNotification";
import SpinnerBox from "./SpinnerBox";
import fireAnalyticsEvent from "../../helpers/editor/fireAnalyticsEvent";
import {getErrorKey} from "../../helpers/editor/getErrorKey";
import {getErrorValue} from "../../helpers/editor/getErrorValue";
import { CrispEvents } from "../../enums/AnalyticsEventsEnums";
import _ from "lodash";
import { GetCurrentStoreData } from "../../store/websites/types";
import { connect } from "react-redux";
import { getCurrentStoreData } from "../../store/websites/thunks";
import { toggleWaitingForResponseOnFontChange } from "../../store/websites/actions";
import classNames from "classnames";
import { googleFontsEnabledClassname } from "../../data/constants";
import LoaderAnimated from "./LoaderAnimated";

interface Props {
    auth: any,
    websites: any,
    toggleWaitingForResponseOnFontChange: any,
    getCurrentStoreData: GetCurrentStoreData,

    fontClassname: string,
    fontTitle: string,
    fontInfo: string,
    saveWebsiteDataInStore: any,
    item: any;
}

class FontOptionItem extends Component<Props>{
    state = {
        beingActivated: false,
        isLoading: false,
    };

    setIsLoading = (isLoading: boolean) => {
        this.setState({ isLoading });
    }

    componentDidMount(): void {
    }

    applyNewFont = (fontClassname:string) => {
        const { currentWebsite } = this.props.getCurrentStoreData();
        this.props.toggleWaitingForResponseOnFontChange(true);
        this.setState({beingActivated: true});
        this.setIsLoading(true);

        let accessToken = this.props.auth.accessToken;
        let apiUrl = api.websites.updateWebsite.prefix + currentWebsite.subdomain + api.websites.updateWebsite.postfix;
        axios.patch(apiUrl, {active_font_classname: fontClassname}, {...returnAuthHeaderForAJAX(accessToken)})
        .then(() => {
                const dataToStore = {
                  data: {
                    ...currentWebsite,
                    active_font_classname: fontClassname
                  }
                }
                this.props.saveWebsiteDataInStore(dataToStore, currentWebsite.subdomain);

                fireAnalyticsEvent.fireCrisp(CrispEvents.changeFont, {
                  subdomain: currentWebsite.subdomain,
                  new_font: currentWebsite.active_font_classname,
                });

            })
            .catch(error => {
                if(error.response){
                    let errorData = error.response.data;
                    if (errorData.detail !== undefined){
                        let message = errorData.detail;

                        let errorObjectKey = getErrorKey(errorData);
                        let errorObjectValue = getErrorValue(errorData, errorObjectKey);

                        fireAnalyticsEvent.fireCrisp(CrispEvents.changeFontError, {
                          error_type: errorObjectKey,
                          error_message: errorObjectValue,
                          subdomain: currentWebsite.subdomain,
                          new_font: fontClassname,
                        }, true);

                        // This happens when user tries to change a website which doesn't exist or doesn't belog to the user.
                        openNotification('Server error', 'Error message: "' + message + '". This should not have happened. Please contact us.', 'OK', 'error');
                    }

                    if (errorData.locked !== undefined){
                        let message = errorData.locked;
                        openNotification('Denied', message, 'OK', 'warn');
                    }

                    if (errorData.active_font_classname !== undefined){
                        let message = errorData.subdomain.join(' ');
                        openNotification('Denied', message, 'OK', 'warn');
                    }
                }
            })
            .then(response => {
                // always executed
                this.props.toggleWaitingForResponseOnFontChange(false);
                this.setState({beingActivated: false});
                this.setIsLoading(false);
            });
    };

    render(){
        const { currentWebsite } = this.props.getCurrentStoreData();
        if (!currentWebsite) return null;
        const isCustomFontActive =
          currentWebsite.active_font_classname === googleFontsEnabledClassname;
        let isActive = currentWebsite.active_font_classname === this.props.fontClassname && !isCustomFontActive;
        let isDisabled = this.props.websites.isWaitingForChangeFontServerResponse;

        return (
            <button
                onClick={() => {
                    this.applyNewFont(this.props.fontClassname)
                }}
                className={classNames("nav-sidebar__theme-item is-font", {
                    "is-active": isActive,
                    "is-loading": this.state.isLoading,
                    "is-disabled": isDisabled,
          })}
          style={{
            fontFamily: `"${this.props.item.fontTitle}", sans-serif`,
          }}
          disabled={isDisabled}
        >
          {this.state.isLoading && <LoaderAnimated />}
          {!this.state.isLoading && "Aa"}
        </button>
      );
    }
}

const mapStateToProps = (state: any) => ({
    auth: state.auth,
    websites: state.websites,
});

export default connect(mapStateToProps, { getCurrentStoreData, toggleWaitingForResponseOnFontChange })(FontOptionItem);
